import { Observable } from 'rxjs';

import FertilizationPlan, {
  FertilizationPlanNeeded,
} from '../interfaces/fertilization-plan';
import FertilizationPlanWarehouse from '../interfaces/fertilization-plan-warehouse';
import FertilizerWithManureCorrections from '../interfaces/fertilizer-with-manure-corrections';
import Paginate from '../interfaces/paginate';
import { Product } from '../interfaces/product';
import { FertilizationPlanTable } from '../pages/crop/fertilization-plan/plan';
import { FertilizationPlanSubmit } from '../pages/crop/fertilization-plan/plan/item';
import { HttpClient, ListParams } from './http-client';

export class FertilizationPlanService extends HttpClient {
  planIndex(
    farmId: string,
    season: string,
    params: ListParams
  ): Observable<Paginate<FertilizationPlanTable>> {
    return this.get<Paginate<FertilizationPlanTable>>(
      `/api/farms/${farmId}/season/${season}/fertilization-plan/plan`,
      params
    );
  }

  exportXls(farmId: string, season: string, params: ListParams) {
    return this.export(
      `/api/farms/${farmId}/season/${season}/fertilization-plan/plan`,
      params
    );
  }

  show(
    farmId: string,
    season: string,
    id: string
  ): Observable<FertilizationPlan> {
    return this.get<FertilizationPlan>(
      `/api/farms/${farmId}/season/${season}/fertilization-plan/plan/${id}`
    );
  }

  store(
    farmId: string,
    season: string,
    plan: FertilizationPlanSubmit
  ): Observable<FertilizationPlan> {
    return this.post<FertilizationPlan>(
      `/api/farms/${farmId}/season/${season}/fertilization-plan/plan`,
      plan
    );
  }

  update(
    farmId: string,
    season: string,
    id: string,
    plan: FertilizationPlanSubmit
  ): Observable<FertilizationPlan> {
    return this.put<FertilizationPlan>(
      `/api/farms/${farmId}/season/${season}/fertilization-plan/plan/${id}`,
      plan
    );
  }

  destroy(
    farmId: string,
    season: string,
    id: string
  ): Observable<FertilizationPlan> {
    return this.delete<FertilizationPlan>(
      `/api/farms/${farmId}/season/${season}/fertilization-plan/plan/${id}`
    );
  }

  needed(
    farmId: string,
    season: string,
    fieldId: string
  ): Observable<FertilizationPlanNeeded> {
    return this.get<FertilizationPlanNeeded>(
      `/api/farms/${farmId}/season/${season}/fertilization-plan/needed/${fieldId}`
    );
  }

  warehouseIndex(
    farmId: string,
    season: string,
    params: ListParams
  ): Observable<Paginate<FertilizationPlanWarehouse>> {
    return this.get<Paginate<FertilizationPlanWarehouse>>(
      `/api/farms/${farmId}/season/${season}/fertilization-plan/warehouse`,
      params
    );
  }

  usedProducts(farmId: string, season: string): Observable<Product[]> {
    return this.get<Product[]>(
      `/api/farms/${farmId}/season/${season}/fertilization-plan/used-products`
    );
  }

  usedFertilizersWithManureCorrections(
    farmId: string,
    season: string,
    params: ListParams
  ): Observable<FertilizerWithManureCorrections[]> {
    return this.get<FertilizerWithManureCorrections[]>(
      `/api/farms/${farmId}/season/${season}/fertilization-plan/used-fertilizers-with-manure-corrections`,
      params
    );
  }

  exportWarehouseXls(farmId: string, season: string, params: ListParams) {
    return this.export(
      `/api/farms/${farmId}/season/${season}/fertilization-plan/warehouse`,
      params
    );
  }
}
